import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'dialog-confirm',
    templateUrl: 'dialog-confirm.component.html',
    standalone: true,
    imports:[
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule
    ]
})

export class DialogConfirmComponent implements OnInit {
    public inputValue: string = '';
    public message: string;
    public inputPlaceholder: string;

    constructor(
        public dialogRef: MatDialogRef<DialogConfirmComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.message = data.message;
        this.inputPlaceholder = data.inputPlaceholder;

    }

    ngOnInit() { }

    onConfirm(): void {
        this.dialogRef.close({ confirmed: true, inputValue: this.inputValue });
      }

      onCancel(): void {
        this.dialogRef.close({ confirmed: false });
      }

}
